import MultiSelectReduxForm from './MultiSelectReduxForm'

export default MultiSelectReduxForm
